import { themeTh } from '@rbilabs/component-library';

export { themeTh as theme };
